import { render, staticRenderFns } from "./AbsenceForm.vue?vue&type=template&id=776f1606"
import script from "./AbsenceForm.vue?vue&type=script&lang=js"
export * from "./AbsenceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports